import React, { useEffect, useState } from 'react';
import tapIcon from '../../services/TapIcon';
import { useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import { Helmet } from 'react-helmet';
import HttpAPICall from "../../services/HttpAPICall";
import { toast } from 'react-toastify';
import TapIcon from '../../services/TapIcon';
import DeviceMapData from './DeviceListingData/DeviceMapData';
import moment from 'moment';

const DeviceData = (props) => {
    const [imei, setImei] = useState('');
    const [loading, setLoading] = useState(false);
    const [deviceData, setDeviceData] = useState(null);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const access_token = useSelector(state => state.auth.access_token);

    const fetchDeviceData = (imeiNumber) => {
        if (!imeiNumber || !imeiNumber.trim()) {
            toast.error('Please enter IMEI number', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        setLoading(true);
        setDeviceData(null);

        HttpAPICall.withAthorization(
            'GET',
            `https://api6.tappetbox.in/api/DeviceData/latest/${imeiNumber}`,
            access_token,
            {},
            {},
            (resp) => {
                setDeviceData(resp.data);
                toast.success('Device data fetched successfully', { position: toast.POSITION.TOP_RIGHT });
            },
            (error) => {
                toast.error('Failed to fetch device data', { position: toast.POSITION.TOP_RIGHT });
            }
        ).then(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        if (props.deviceData?.imei_no) {
            setImei(props.deviceData.imei_no);
            setBtnDisabled(true);
            fetchDeviceData(props?.deviceData?.imei_no);
        }
    }, [props.deviceData?.imei_no]);


    const openGoogleMaps = () => {
        if (!deviceData || !deviceData.latitude || !deviceData.longitude) {
            toast.error('Location data not available', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const { latitude, longitude } = deviceData;
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank');
    };

    const formatValue = (key, value) => {
        if (value === null || value === undefined) return 'N/A';

        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (typeof value === 'number') {
            switch (key) {
                case 'speed':
                    return `${value} km/h`;
                case 'direction':
                    return `${value}°`;
                case 'altitude':
                    return `${value} m`;
                case 'externalVoltage':
                case 'batteryVoltage':
                    return `${value} V`;
                default:
                    return value.toString();
            }
        }

        if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
            return moment(value).format('DD-MMM-YYYY HH:mm:ss');
        }

        return value.toString();
    };

    const renderDeviceData = () => {
        if (!deviceData) return null;

        return (
            <div className="row my-4">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="card-title mb-0">Device Information</h5>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={openGoogleMaps}
                                disabled={!deviceData.latitude || !deviceData.longitude}
                            >
                                <TapIcon.FontAwesomeIcon icon={TapIcon.faMap} className="me-2" />
                                Map View
                            </button>
                        </div>
                        <table className="table table-hover table-borderless">
                            <tbody>
                                {(() => {
                                    const entries = Object.entries(deviceData)
                                        .filter(([key]) => key !== 'deviceAsset');

                                    const rows = [];
                                    for (let i = 0; i < entries.length; i += 2) {
                                        rows.push(entries.slice(i, i + 2));
                                    }

                                    return rows.map((row, index) => (
                                        <tr key={index}>
                                            {row.map(([key, value]) => (
                                                <React.Fragment key={key}>
                                                    <td className="details-label" style={{ width: "17%" }}>
                                                        {key}
                                                    </td>
                                                    <td className="details-name" style={{ width: "33%" }}>
                                                        {formatValue(key, value)}
                                                    </td>
                                                </React.Fragment>
                                            ))}
                                            {row.length === 1 && (
                                                <>
                                                    <td></td>
                                                    <td></td>
                                                </>
                                            )}
                                        </tr>
                                    ));
                                })()}
                            </tbody>

                        </table>
                    </div>

                </div>
            </div>
        );
    };

    return (
        <>
            <Helmet><title>Device Data</title></Helmet>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white p-3">
                            {props?.deviceData?.asset &&
                                <table className="table table-hover table-borderless mt-2">
                                    <tbody>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}>Asset </td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.asset?.asset_name || "-"}({props?.deviceData?.asset?.asset_nickname || "-"})</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}> Group</td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.group?.group_name || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }

                            <div className="row align-items-center my-3">
                                <div className="col-sm-4">
                                    <label htmlFor="imei" className="form-label require">IMEI Number</label>
                                </div>
                                <div className="col-sm-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={imei || ''}
                                        readOnly
                                        disabled
                                        placeholder="IMEI Number"
                                    />
                                </div>
                                <span className="col-sm-2 ms-4">
                                    <button
                                        onClick={() => {
                                            fetchDeviceData(props.deviceData?.imei_no)
                                        }}
                                        type="submit"
                                        className="btn btn-secondary">
                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} />
                                    </button> </span>
                            </div>

                            {loading && <Loader />}
                            {renderDeviceData()}

                            <div className="my-4" >
                                {deviceData && (
                                    <>
                                        <DeviceMapData data={[deviceData]} deviceName={props.deviceData?.imei_no?.asset?.asset_name} />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeviceData;